<template>
  <div>
    <div class="tw-mb-4 tw-flex">
      <span class="tw-mr-1">
        <cb-icon-domain :width="24" :height="24" />
      </span>
      <cl-p> {{ $t("domain-information") }} </cl-p>
    </div>
    <div class="tw-mb-4 tw-flex">
      <span class="tw-text-base tw-font-bold">{{
        domainInformation.domain
      }}</span>
    </div>
    <div class="tw-mb-4 tw-flex tw-flex-col md:tw-flex-row">
      <div class="tw-h-6 tw-pr-6 md:tw-border-r md:tw-border-primary-grey-300">
        <span
          >{{ `${$t("country-origin")} ` }} {{ domainInformation.origin }}</span
        >
      </div>
      <div
        class="tw-h-6 tw-pr-6 md:tw-border-r md:tw-border-primary-grey-300 md:tw-pl-6"
      >
        <span
          >{{ `${$t("mail-flow-title")} ` }}
          {{ domainInformation.mail_flow }}</span
        >
      </div>
      <div class="tw-h-6 tw-pr-6 md:tw-pl-6">
        <span>{{ `${$t("host")} ` }} {{ domainInformation.host }}</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { IncidentDetailsDomainInformation } from "@/modules/PhishTitan/types/IncidentSummary";

defineProps<{ domainInformation: IncidentDetailsDomainInformation }>();
</script>
